import { Component, Input } from '@angular/core';
import { DateFormat, TextFormat } from 'src/app/shared/enums';
import { ICell } from 'src/app/shared/interfaces/ITable';
import { formatDateToLocalTimeZone, formatDateOrTime } from 'src/app/shared/utils';

@Component({
  selector: 'app-text-formatter',
  standalone: true,
  templateUrl: './text-formatter.component.html',
  styleUrls: ['./text-formatter.component.scss']
})
export class TextFormatterComponent {
  @Input() cell: ICell;
  @Input() format: TextFormat;
  @Input() maxLine = 4;

  get formatText() {
    const { row, column } = this.cell;
    const origin = row[column.key];
    switch (this.format) {
      case TextFormat.DAY:
        return formatDateOrTime(origin);
      case TextFormat.TIME:
        return formatDateOrTime(origin, DateFormat.TIME);
      case TextFormat.DECIMAL:
        return parseFloat(origin).toFixed(6);
      case TextFormat.DATE_TIME_ZONE:
        return formatDateToLocalTimeZone(origin);
      default:
        return origin;
    }
  }
}
